import { useCurrentOrganizationFromContext } from "../providers/UserInfoProvider"

export const useCurrentOrganization = () => {
  return useCurrentOrganizationFromContext()
}
